module.exports = __webpack_public_path__ + "static/media/sostentitori.d6a39018.svg";